import { render, staticRenderFns } from "./_TimeRules.vue?vue&type=template&id=15d8515c&scoped=true"
import script from "./_TimeRules.vue?vue&type=script&lang=ts"
export * from "./_TimeRules.vue?vue&type=script&lang=ts"
import style0 from "./_TimeRules.vue?vue&type=style&index=0&id=15d8515c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d8515c",
  null
  
)

export default component.exports